export type UserRole = 'admin' | 'manager' | 'warehouse' | 'viewer';

export type ModuleKey =
  | 'purchases'
  | 'production'
  | 'stock'
  | 'references'
  | 'marketing'
  | 'reports'
  | 'invoices';

export type AccessLevel = 'view' | 'edit';

/** Per-module access map for non-admins. Admins bypass it (is_admin=true). */
export type ModuleAccess = Partial<Record<ModuleKey, AccessLevel>>;

export type ProductNameDisplayLanguage = 'uk' | 'en' | 'it' | 'de';

export const PRODUCT_NAME_DISPLAY_LANGUAGES: {
  value: ProductNameDisplayLanguage;
  label: string;
}[] = [
  { value: 'uk', label: 'Українська' },
  { value: 'it', label: 'Італійська' },
  { value: 'en', label: 'Англійська' },
  { value: 'de', label: 'Німецька' },
];

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: UserRole;
  is_admin: boolean;
  module_access: ModuleAccess;
  /** Якою мовою людина бачить назви виробів (профіль). Немає перекладу — українська. */
  product_name_language: ProductNameDisplayLanguage;
  is_active: boolean;
  is_staff: boolean;
  date_joined: string;
  created_at: string;
  updated_at: string;
}

export interface AuthTokens {
  access: string;
  refresh: string;
}

export interface LoginResponse extends AuthTokens {
  user: User;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}
